// src/components/Layout.jsx

import React, { useState, useEffect } from 'react';
import { HiMenu, HiX, HiArrowLeft, HiLocationMarker } from 'react-icons/hi'; // HiLocationMarker eklendi
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import TestimonialsCarousel from '../components/Testimonials';
import { FaLinkedin, FaMedium, FaRss } from 'react-icons/fa';
// import ResumeUpload from './ResumeUpload';

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItemClass =
    'px-4 py-2 rounded-md font-medium text-white bg-blue-600 hover:bg-blue-700 transition text-center';

  const isHome = location.pathname === '/';

  // **YENİ KONTROL: Eğitim Dashboard'u rotasında mıyız?**
  const isEducationDashboard = location.pathname.startsWith('/sura-dashboard');

  // Show back button on login or any /register/* page
  const showBackButton =
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/register');

  // Google Analytics Page View Tracking
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-0Z0X0FHBRF', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  // **Koşullu Rendering Başlangıcı**
  // Eğer Eğitim Dashboard'unda isek, sadece içeriği (Outlet) döndür.
  if (isEducationDashboard) {
    return (
      <div className='min-h-screen font-sans'>
        {/* Eğitim Dashboard'u için temel SEO (opsiyonel) */}
        <Helmet>
          <title>Eğitim Dashboard | Sure Ezberleme</title>
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Outlet />
      </div>
    );
  }
  // **Koşullu Rendering Sonu**

  // --- Kariyer Koçluğu Layout'u (Varsayılan) ---
  return (
    <div className='min-h-screen flex flex-col bg-gray-50 font-sans'>
      {/* Helmet SEO (Kariyer Odaklı) */}
      <Helmet>
        {isHome ? (
          <>
            <title>Next Interview Blueprint | Job Interview Preparation</title>
            <meta
              name='description'
              content='Ace your next job interview with resume reviews, mock interviews, and LinkedIn optimization. Get expert career coaching to land your dream job.'
            />
            <meta
              name='keywords'
              content='job interview preparation, resume review, interview coaching, LinkedIn optimization, career mentor'
            />
            <meta name='publisher' content='Next Interview Blueprint' />
            <meta name='author' content='Recep Taylanhan' />
            <meta property='og:title' content='Next Interview Blueprint' />
            <meta
              property='og:description'
              content='Career coaching, resume reviews, and interview prep to help you land your dream job.'
            />
            <meta
              property='og:url'
              content='https://www.nextinterviewblueprint.com'
            />
            <meta property='og:type' content='website' />
            <meta
              property='og:image'
              content='https://www.nextinterviewblueprint.com/preview.png'
            />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content='Next Interview Blueprint' />
            <meta
              name='twitter:description'
              content='Free 30-min job hunting session. Get resume reviews, interview prep, and LinkedIn coaching.'
            />
            <meta
              name='twitter:image'
              content='https://www.nextinterviewblueprint.com/preview.png'
            />
            <link
              rel='canonical'
              href='https://www.nextinterviewblueprint.com/'
            />
            <script type='application/ld+json'>
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'ProfessionalService',
                name: 'Next Interview Blueprint',
                url: 'https://www.nextinterviewblueprint.com',
                logo: 'https://www.nextinterviewblueprint.com/preview.png',
                sameAs: [
                  'https://www.linkedin.com/in/recep-taylanhan/',
                  'https://medium.com/@recep_taylanhan',
                ],
                description:
                  'Career coaching including resume reviews, mock interviews, and LinkedIn optimization.',
              })}
            </script>
          </>
        ) : (
          <meta name='robots' content='noindex, nofollow' />
        )}
      </Helmet>

      {/* Header */}
      <header className='bg-white shadow-md py-4 px-6 flex justify-between items-center sticky top-0 z-50'>
        <h1
          onClick={() => navigate('/')}
          className='text-2xl md:text-3xl font-extrabold text-blue-600 cursor-pointer'
        >
          NextInterviewBlueprint
        </h1>

        {/* Desktop Navigation */}
        <nav className='hidden md:flex space-x-4'>
          {/* YENİ BUTON: Namaz Vakitleri Sayfasına Geçiş */}
          {/* <button 
              onClick={() => navigate('/prayer-times')} 
              className='px-4 py-2 rounded-md font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition text-center flex items-center'
          >
              <HiLocationMarker className='w-5 h-5 mr-2 text-indigo-600' />
              Prayer Times
          </button> */}
          
          <button onClick={() => navigate('/login')} className={menuItemClass}>
            Login
          </button>
          <button
            onClick={() => navigate('/register')}
            className={menuItemClass}
          >
            Register
          </button>
        </nav>

        {/* Mobile Hamburger Menu */}
        <div className='md:hidden'>
          {/* Mobil Menü İçine de Namaz Vakitleri Butonu Ekle */}
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? (
              <HiX className='w-6 h-6 text-gray-700' />
            ) : (
              <HiMenu className='w-6 h-6 text-gray-700' />
            )}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className='md:hidden fixed top-16 left-0 w-full bg-white shadow-md z-50 flex flex-col space-y-2 px-6 py-4'>
          {/* Mobil Menü İçine Namaz Vakitleri Butonu */}
          {/* <button
            onClick={() => {
              navigate('/prayer-times');
              setMenuOpen(false);
            }}
            className='px-4 py-2 rounded-md font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition text-center flex items-center justify-center'
          >
              <HiLocationMarker className='w-5 h-5 mr-2 text-indigo-600' />
              Prayer Times
          </button> */}

          <button
            onClick={() => {
              navigate('/login');
              setMenuOpen(false);
            }}
            className={menuItemClass}
          >
            Login
          </button>
          <button
            onClick={() => {
              navigate('/register');
              setMenuOpen(false);
            }}
            className={menuItemClass}
          >
            Register
          </button>
        </div>
      )}

      {/* Main Content */}
      <main className='flex-grow container mx-auto px-4 py-6 space-y-12'>
        {/* Back Button for Login/Register Pages */}
        {showBackButton && (
          <button
            onClick={() => navigate('/')}
            className='flex items-center text-blue-600 font-medium mb-4'
          >
            <HiArrowLeft className='w-5 h-5 mr-2' />
            Back to Home
          </button>
        )}

        {/* Home Page Hero Section */}
        {isHome && (
          <>
            {/* YENİ: Namaz Vakitleri sayfasına yönlendiren CTA */}
            {/* <div className='text-center mb-8'>
                <button
                    onClick={() => navigate('/prayer-times')}
                    className='px-6 py-3 bg-indigo-500 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-600 transition flex items-center justify-center mx-auto'
                >
                    <HiLocationMarker className='w-6 h-6 mr-2' />
                    Check Local Prayer Times
                </button>
            </div> */}
            
            <section className='text-center py-12 bg-gradient-to-r from-blue-50 to-indigo-100 rounded-xl shadow-lg'>
              <h1 className='text-3xl md:text-4xl font-bold text-indigo-700 mb-3'>
                Land Your Dream Job
              </h1>
              <p className='text-base md:text-lg text-gray-700 mb-5 max-w-xl mx-auto'>
                Get resume reviews, interview prep, and LinkedIn coaching from
                an experienced career mentor.
              </p>
              <a
                href='https://calendly.com/nextinterviewblueprint/30min'
                target='_blank'
                rel='noopener noreferrer'
                className='px-4 py-2 md:px-6 md:py-3 bg-yellow-400 text-gray-900 font-medium rounded-full shadow-md hover:bg-yellow-300 transition'
              >
                🎁 Claim 30-Min Free Job Hunting Session
              </a>
            </section>

            {/* Services */}
            <section className='py-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto'>
              <div className='bg-white shadow-lg rounded-lg p-6 text-center hover:scale-105 transition transform'>
                <h3 className='text-xl font-semibold text-blue-700 mb-2'>
                  Resume Review
                </h3>
                <p className='text-gray-600'>
                  Get your resume reviewed with actionable feedback to make it
                  stand out.
                </p>
              </div>
              <div className='bg-white shadow-lg rounded-lg p-6 text-center hover:scale-105 transition transform'>
                <h3 className='text-xl font-semibold text-blue-700 mb-2'>
                  Interview Prep
                </h3>
                <p className='text-gray-600'>
                  Mock interviews and tips tailored to your career goals.
                </p>
              </div>
              <div className='bg-white shadow-lg rounded-lg p-6 text-center hover:scale-105 transition transform'>
                <h3 className='text-xl font-semibold text-blue-700 mb-2'>
                  LinkedIn Optimization
                </h3>
                <p className='text-gray-600'>
                  Optimize your LinkedIn profile to attract recruiters and
                  opportunities.
                </p>
              </div>
            </section>

            {/* Testimonials */}
            <TestimonialsCarousel />

            {/* Newsletter */}
            <section className='text-center py-8 bg-blue-50 rounded-lg shadow-md'>
              <h3 className='text-2xl font-semibold text-blue-700 mb-4'>
                Stay Updated
              </h3>
              <p className='text-gray-700 mb-4'>
                Get career tips, resources, and updates delivered to your inbox.
              </p>
              <a
                href='https://taylanhanr.substack.com/subscribe'
                target='_blank'
                rel='noopener noreferrer'
                className='inline-block px-6 py-3 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition'
              >
                Subscribe
              </a>
            </section>
            
            {/* Floating CTA */}
            <a
              href='https://calendly.com/nextinterviewblueprint/30min'
              target='_blank'
              rel='noopener noreferrer'
              className='sticky bottom-4 mx-auto block w-max bg-yellow-400 text-gray-900 font-bold px-4 py-2 text-sm md:px-6 md:py-3 md:text-base rounded-full shadow-lg hover:bg-yellow-300 transition'
            >
              Free 30-min Session
            </a>
          </>
        )}

        {/* Render the current page */}
        <Outlet />
      </main>

      {/* Footer */}
      <footer className='bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 text-white py-8'>
        <div className='max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
          <p className='text-sm md:text-base font-semibold'>
            &copy; {new Date().getFullYear()} The Next Interview Blueprint
          </p>
          <div className='flex space-x-6'>
            <a
              href='https://www.linkedin.com/in/recep-taylanhan/'
              target='_blank'
              rel='noopener noreferrer'
              className='hover:text-gray-200 transition flex items-center space-x-1'
            >
              <FaLinkedin className='w-5 h-5' />
              <span className='hidden md:inline'>LinkedIn</span>
            </a>
            <a
              href='https://gothenextintreviewblueprint.substack.com/subscribe'
              target='_blank'
              rel='noopener noreferrer'
              className='hover:text-gray-200 transition flex items-center space-x-1'
            >
              <FaRss className='w-5 h-5' />
              <span className='hidden md:inline'>Substack</span>
            </a>
            <a
              href='https://medium.com/@recep_taylanhan/subscribe'
              target='_blank'
              rel='noopener noreferrer'
              className='hover:text-gray-200 transition flex items-center space-x-1'
            >
              <FaMedium className='w-5 h-5' />
              <span className='hidden md:inline'>Medium</span>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}